"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const warn = s => {
  console.warn('[react-gtm]', s);
};
var _default = exports.default = warn;